const state = () => {
  return {
    visible: true
  }
}

const mutations = {
  setVisible (state, visible) {
    state.visible = visible
  },
  hide (state, visible) {
    state.visible = false
  }
}

const getters = {
  getVisible (state) {
    return state.visible
  }
}

export {
  state,
  mutations,
  getters
}
